



import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyADhoE9kyOJ7DSlhRHFt2NySaQZNmCtLiw",
  authDomain: "prothama-lifespace.firebaseapp.com",
  projectId: "prothama-lifespace",
  storageBucket: "prothama-lifespace.firebasestorage.app",
  messagingSenderId: "621185005221",
  appId: "1:621185005221:web:66861e18333d761824ff4c",
  measurementId: "G-BZLYL9NYFE"
 
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;



